/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Tags_Manager_Error_Save_Set_ToastInputs */

const en_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error saving set: ${i?.error}`)
};

const fr_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de l'enregistrement de l'ensemble : ${i?.error}`)
};

const de_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Speichern des Satzes: ${i?.error}`)
};

const it_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante il salvataggio del set: ${i?.error}`)
};

const ru_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка сохранения набора: ${i?.error}`)
};

const es_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al guardar el conjunto: ${i?.error}`)
};

const zh_cn2_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保存数据集时出错：${i?.error}`)
};

const ja_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`セットの保存中にエラーが発生しました: ${i?.error}`)
};

const hi_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सेट सहेजने में त्रुटि: ${i?.error}`)
};

const pt_pt2_tags_manager_error_save_set_toast = /** @type {(inputs: Tags_Manager_Error_Save_Set_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao salvar o conjunto: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error saving set: {error}" |
*
* @param {Tags_Manager_Error_Save_Set_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_save_set_toast = /** @type {((inputs: Tags_Manager_Error_Save_Set_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Save_Set_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_error_save_set_toast(inputs)
	if (locale === "de") return de_tags_manager_error_save_set_toast(inputs)
	if (locale === "it") return it_tags_manager_error_save_set_toast(inputs)
	if (locale === "ru") return ru_tags_manager_error_save_set_toast(inputs)
	if (locale === "es") return es_tags_manager_error_save_set_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_error_save_set_toast(inputs)
	if (locale === "ja") return ja_tags_manager_error_save_set_toast(inputs)
	if (locale === "hi") return hi_tags_manager_error_save_set_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_error_save_set_toast(inputs)
	return en_tags_manager_error_save_set_toast(inputs)
});